import React, {useState} from 'react';

import {Box, TextField, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {StyledCard} from './styles';
import {OtherCommentsProps} from './types';

const {others, othersPlaceholder, othersMaxCharacters} =
	translations['pt-br'].privateFlow.fiveStarsRating;

const MAX_LIMIT_CHARACTERS = 256;

export function OtherComments(props: OtherCommentsProps) {
	const [inputFieldState, setInputFieldState] = useState('');
	const inputFieldCharacters = inputFieldState.length;

	return (
		<StyledCard>
			<Box display="flex" justifyContent="space-between" alignItems="center">
				<Typography>{others}</Typography>
				<Typography variant="caption" color="text.secondary">
					{inputFieldCharacters}/{MAX_LIMIT_CHARACTERS}
				</Typography>
			</Box>
			<TextField
				{...props}
				multiline
				onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
					setInputFieldState(event.target.value);
					if (props.onChange) props.onChange(event);
				}}
				placeholder={othersPlaceholder}
				helperText={othersMaxCharacters}
				slotProps={{htmlInput: {maxLength: MAX_LIMIT_CHARACTERS}}}
			/>
		</StyledCard>
	);
}
